import React, { useState, useEffect } from "react";
import { EditField } from "../types";
import colors from "../../../colors/colors";

interface TextFieldProps {
  value: string;
  onChange: (value: string) => void;
  field: EditField;
}

export const TextField: React.FC<TextFieldProps> = ({ value, onChange }) => {
  // Use local state to preserve cursor position during typing
  const [localValue, setLocalValue] = useState(value || "");

  // Sync local state when external value changes (e.g., from saved config)
  useEffect(() => {
    setLocalValue(value || "");
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setLocalValue(newValue);
    onChange(newValue);
  };

  return (
    <input
      type="text"
      value={localValue}
      onChange={handleChange}
      className="edit-panel-input"
      style={{
        width: "100%",
        padding: "12px 14px",
        border: `1px solid ${colors.border_glass}`,
        borderRadius: "10px",
        fontSize: "13px",
        color: colors.primary,
        boxSizing: "border-box",
        transition: "all 0.15s ease",
        background: colors.white,
        outline: "none",
      }}
    />
  );
};
